export default __webpack_public_path__ + "static/media/woman1.a1099b32.png";